<template>
    <div>
        <v-simple-table class="table-layout pa-5">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>Tên</th>
                        <th>Mã</th>
                        <th>Mô tả</th>
                        <th>Thao tác</th>
                    </tr>
                </thead>
                <tbody v-for="(item, index) in schoolLevelList" :key="index">
                    <tr>
                        <td>{{ item.name }}</td>
                        <td>{{ item.code }}</td>
                        <td>{{ item.description }}</td>
                        <td>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon 
                                            color="info" 
                                            style="cursor: pointer" 
                                            title="Cập nhật"
                                            @click="editSchoolLevel(item)"
                                            v-if="checkAuthorization('school-level_update')"
                                            v-on="on">
                                        mdi-pencil
                                    </v-icon>
                                </template>
                                <span>Cập nhật</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon 
                                            color="error" 
                                            style="cursor: pointer" 
                                            title="Xóa"
                                            @click="deleteSchoolLevel(item.id)"
                                            v-if="checkAuthorization('school-level_delete')"
                                            v-on="on">
                                        mdi-delete
                                    </v-icon>
                                </template>
                                <span>Xóa</span>
                            </v-tooltip>
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="schoolLevelList.length == 0">
                    <tr>
                        <td colspan="100">
                            <common-no-result />
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
export default {
    props: {
        schoolLevelList: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        editSchoolLevel(schoolLevel) {
            Bus.$emit('school-level-show-form', schoolLevel)
        },
        
        deleteSchoolLevel(id) {
            this.$swal({
                title: 'Bạn có chắc muốn xóa nhóm ngành này?',
                width: '550px',
                showCancelButton: true,
                cancelButtonText: 'Hủy',
                confirmButtonText: 'Đồng ý'
            }).then(res => {
                if (res.value) {
                    Bus.$emit('delete-school-level', id)
                }
            })
        }
    }
}
</script>

<style scoped>
/deep/ table tr {
    height: 40px;
}

/deep/ table tr td {
    border-bottom: 1px solid #DDDDDD;
    height: 40px !important;
}

.v-icon {
    outline: unset;
}
</style>